"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageType = {
    RPC: 'R',
    HEART: 'H',
    MESSAGE_ACK: 'A',
    ERROR: 'E',
    MESSAGE: 'M'
};
exports.login = {
    type: exports.MessageType.RPC,
    service: 'auth',
    method: 'login'
};
exports.heartbeat = {
    type: exports.MessageType.HEART
};
exports.sendMessage = {
    type: exports.MessageType.RPC,
    service: 'message',
    method: 'p2p'
};
// 服务端主动推送的消息
exports.serverPush = {
    type: exports.MessageType.MESSAGE
};
// 对服务器主动推送的响应
exports.messageAck = {
    type: exports.MessageType.MESSAGE_ACK
};
// export const fetchMessageHistory: Template = {
//   service: '',
//   method: '',
// };
// export const passivityLogout: Template = {
//   service: '',
//   method: '',
// };
function matchTemplate(src, template) {
    return (src.type === template.type && src.service === template.service && src.method === template.method);
}
exports.matchTemplate = matchTemplate;
exports.template = {
    login: exports.login,
    heartbeat: exports.heartbeat,
    sendMessage: exports.sendMessage,
    messageAck: exports.messageAck,
    serverPush: exports.serverPush
};
function decodeTemplateName(src) {
    for (var key in exports.template) {
        if (matchTemplate(src, exports.template[key])) {
            return key;
        }
    }
    return null;
}
exports.decodeTemplateName = decodeTemplateName;
exports.default = exports.template;
//# sourceMappingURL=template.js.map